import React from "react";
import { AiOutlineArrowRight } from "react-icons/ai";

const Fucfact = () => {
  const funFacts = [
    "⭐️ 4.97 Uber rating",
    {
      text: "🍜 Rated 100+ restaurants on Beli",
      link: "https://beliapp.co/app/ehan0212"
    },
    "✈️ United Airlines Gold Member",
    "As you can tell, I'm extremely passionate about fashion and food!"
  ];

  return (
    <div id="fun-facts" className="portfolio">
      <h1 className="mainHeading">Fun Facts</h1>
      <p className="mainPara">Little things that make me, me!</p>
      <div className="projects">
        {funFacts.map((item, index) => (
          <div className="project" key={index} style={{ padding: "15px" }}>
            <h4 className="projectTitle" style={{ fontSize: "1.3rem", padding: "0px" }}>
              {typeof item === "string" ? (
                item
              ) : (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="projectLink"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {item.text} <AiOutlineArrowRight className="proIcon" />
                </a>
              )}
            </h4>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Fucfact;
